export function getImageURL(imageId, variant = 'public') {
  return `https://imagedelivery.net/rfsrmrTRTTug_lRfZe2CFQ/${imageId}/${variant}`;
}
